// extracted by mini-css-extract-plugin
export var alertIcon = "_qq-0";